import TotalByLevel from "./TotalByLevel";

export default TotalByLevel;
